<template>
  <div class="page-wrapper about-page about">
    <div class="about-background"></div>
    <div class="nav-info">
      <NavInfo/>
    </div>
    <main class="about-info" id="topPage">
      <h1 class="wcrc">About</h1>

      <p>
        Greenham Woman Digital is an archival and interactive website that preserves the experience of the Greenham
        Common Women’s Peace Camp (GCWPC).
      </p>
      <p>
        In September 1981, women around the UK descended on Berkshire in beautiful indignation against the storage of
        American nuclear missiles in the UK. They created Greenham Common Women's Peace Camp. They created an
        exclusively female space and thrived together, pushing those watching to question war, sexual orientation, and
        gender roles. The stories that inspired tens of thousands of women around the world have been preserved and are
        waiting for you here.
      </p>
      <p>
        Like every organic movement, there were different ideologies within Greenham. Some believed in absolute female
        exclusivity or were focused on artistic actions, while others were academic or intent on consciousness raising.
        Like-minded women gravitated towards each other and shared space in the different gates of the camp.
      </p>

      <p>
        Come explore the ethos of Violet, Indigo, Turquoise, Red, Orange, Emerald, Green, Blue, and Yellow gates. You'll
        find interactive multimedia within each gate. Discover and collect songs, stories and accounts hidden in the 3D
        and 2D 'gates' by clicking on what you can see and explore everyday life, protest and actions, love and loss at
        Greenham Common Women's Peace Camp. And rediscover this integral piece of British history.
      </p>
      <p>
        Turn your sound on before you explore the site to enjoy the rich audio soundscape, which have been created from
        the minds and memories of Greenham Women. And keep your eyes open - there's treasure to be found and collected!
        Click on interesting objects and you may be rewarded with deeper detail about life at the camp. Much of what
        you'll see and hear is based on fictionalised or verbatim interviews with Greenham Women all of which and more
        can be found on the <a href="http://greenhamwomeneverywhere.co.uk/" target="_blank">Greenham Women
        Everywhere</a> site.
      </p>
      <p>
        This site was created with and by Greenham Women artists and by creatives at <a
          href="https://scarylittlegirls.co.uk" target="_blank">Scary Little Girls</a> and <a
          href="https://www.animorph.coop/" target="_blank">Animorph</a>.
      </p>
      <div class="logos">
        <img src="/images/logos/lottery_arts_council.png"
             alt="Fundingfor this project from Arts Council England National Lottery Project Grants">
      </div>
    </main>
  </div>
</template>

<script>
import NavInfo from "../components/NavInfo";

export default {
  name: "About",
  components: {
    NavInfo,
  },
  data() {
    return {}
  },

  methods: {},
  mounted() {
    document.getElementById("topPage").scrollIntoView();
  }
}
</script>

<style scoped>
.about p:first-of-type {
  font-size: 1.5em;
  line-height: 1.25;
}

.logos img {
  padding-top: 3em;
  max-width: 20em;
  height: auto;
}
</style>
